import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import HeaderPage from '../components/HeaderPage';
import Footer from '../components/Footer';

function ErrorPage() {
   return (
      <>
         <HeaderPage
				pageName={'Page not found'}
				subtitle={'Opsss!'}
				icon={<FontAwesomeIcon icon={solid('bug')} className="badge-icon" />}
			/>

			<motion.main
				className="container"

				initial={{ opacity: 0, y: '100%' }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: .8, ease: 'easeInOut' }}
				exit={{ opacity: 0, y: '100%' }}
			>
				<section className="txt-center">
					<h1>404 Error</h1>
					<p className="mb-2">Sorry, The page you're looking for doesn't exist or can't be found.</p>

					<Link to='/' className="badge">Back to Homepage</Link>
				</section>
			</motion.main>

			<Footer />
      </>
   );
}

export default ErrorPage;